import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "climbarena.fr",
  favicon: "/climbarena-logo.svg",
  companyName: "Climb Arena",
  website: 'https://www.climbarena.fr/',
  notifyChannel: 'vel-climbarena',
  onlyOneClub: true,
  htmlCustomCSS: "climbarena.scss",
  header: {
    title: "",
    logo: "/climbarena-logo.svg",
  },
  plans: {
    ...configDefault.plans,
    withBanner: true,
    splitCounterAbo: {
      passText: ["Séances et packs"],
    },
    feesLabelComplement: "Abonnement avec 8 semaines de préavis après la période de gratuité. Hors 10€/an pour le renouvellement matériel.",
  },
  options: {
    title: "Je choisis mes options",
    message: "",
    nextLabel: "Suivant",
  },
  navigation: {
    ...configDefault.navigation,
    display: "line"
  },
  steps: {
    ...configDefault.steps,
    display: {
      showShortNames: false,
    },
    userForm: {
      ...configDefault.steps.userForm,
      optins: {
        acceptNewsletter: {
					...configDefault.steps.userForm.optins.acceptNewsletter,
					text: "Je souhaite recevoir les actualités, informations et conseils de Climb Arena par mail ou SMS",
				},
				acceptAdvertising: {
					...configDefault.steps.userForm.optins.acceptAdvertising,
					text: "J'accepte de recevoir les offres commerciales personnalisées de Climb Arena",
				},
				acceptPartner: {
					...configDefault.steps.userForm.optins.acceptPartner,
					text: "J'autorise Climb Arena à transmettre mes coordonnées à ses partenaires sélectionnés afin de recevoir leurs offres et communications",
				},
      },
      displayFirstOffer: false,
    }
  },
  payment: {
    ...configDefault.payment,
    paylineTitle: "Finalisez votre inscription...",
    paylineLabel: "Il ne vous reste plus qu'une étape pour rejoindre Climb Arena : votre inscription sera confirmée dès le règlement par carte bancaire des frais d’inscription de ",
  },
  footer: {
    ...configDefault,
    logo: null,
    textLine: "",
    cgv: {
      link: "https://www.climbarena.fr/cgv/",
      text: "Mentions légales et CGU/CGV",
    },
  },
};

export default config;
